export const KeyContactIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width='15'
    height='14'
    viewBox='0 0 15 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M7.9729 14C11.8389 14 14.9729 10.866 14.9729 7C14.9729 3.13401 11.8389 0 7.9729 0C4.10691 0 0.9729 3.13401 0.9729 7C0.9729 10.866 4.10691 14 7.9729 14Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1198 11.1998C10.0511 11.1998 9.98389 11.19 9.91826 11.1703C9.85264 11.1506 9.7917 11.121 9.73545 11.0816L7.97295 9.95901L6.21045 11.0915C6.08545 11.1637 5.94951 11.1982 5.80264 11.1949C5.65576 11.1916 5.52295 11.1473 5.4042 11.0619C5.28545 10.9766 5.19951 10.8633 5.14639 10.7222C5.09326 10.581 5.08232 10.435 5.11357 10.284L5.52607 8.1372L4.0167 6.75854C3.91045 6.66663 3.83857 6.54846 3.80107 6.40403C3.76357 6.2596 3.76357 6.11517 3.80107 5.97073C3.84482 5.83286 3.91982 5.7147 4.02607 5.61622C4.13232 5.51774 4.2542 5.45866 4.3917 5.43896L6.48232 5.10415L7.30732 3.24295C7.36982 3.10508 7.46045 2.99676 7.5792 2.91798C7.69795 2.8392 7.8292 2.7998 7.97295 2.7998C8.1167 2.7998 8.24795 2.8392 8.3667 2.91798C8.48545 2.99676 8.57608 3.10508 8.63858 3.24295L9.46357 5.10415L11.5542 5.43896C11.6917 5.45866 11.8136 5.51774 11.9198 5.61622C12.0261 5.7147 12.1011 5.83286 12.1448 5.97073C12.1823 6.11517 12.1823 6.2596 12.1448 6.40403C12.1073 6.54846 12.0323 6.66663 11.9198 6.75854L10.4292 8.1372L10.8417 10.284C10.8667 10.435 10.8526 10.581 10.7995 10.7222C10.7464 10.8633 10.6573 10.9766 10.5323 11.0619C10.4761 11.1079 10.412 11.1424 10.3401 11.1653C10.2683 11.1883 10.1948 11.1998 10.1198 11.1998Z'
      fill='#fff'
    />
  </svg>
);
